import { LOADER } from "../definitions";

export const startloading = () => async (dispatch) => {
  dispatch({
    type: LOADER.START_LOADER,
    payload: true,
  });
};

export const endloading = () => async (dispatch) => {
  dispatch({
    type: LOADER.END_LOADER,
    payload: false,
  });
};
